import {
  IOnlineUserData,
  IUserDisplayData,
  UserDisplayDataType,
  UserOnlineStatus,
} from '@gem/models/userModel';
import { clearPhoneNumber } from '@gem/utils';

import { IUser } from 'APP/model/auth/authModel.types';
import { IGetUsersByEmailsParams } from 'APP/model/user/userModel.types';
import { WsRequest } from 'APP/wsApi/wsAppApi/requests/request.types';
import {
  PersonalizedUser,
  User,
  UserStatus,
  UserStatus_Status,
} from 'APP/wsApi/wsAppApi/types/user/user_model_pb';
import { GetUsersByEmailsRequest } from 'APP/wsApi/wsAppApi/types/user/user_requests_pb';

export function mapPersonalizedUserResponse(personalizedUser: PersonalizedUser): IUserDisplayData {
  const user = personalizedUser.user;

  return {
    id: user?.id.toString() || '',
    userName: user?.username || '',
    nickName: user?.nickname || '',
    avatarUrl: user?.avatarUrl || '',
    phone: clearPhoneNumber(user?.phone),
    position: user?.position,
    email: user?.email,
    lastOnline: personalizedUser.lastOnlineTs.toString(),
    privacyStatus: {
      addToGroup: true,
      addToPublic: true,
      callMe: true,
      searchMe: true,
      sendVoiceMessage: true,
      showLastSeen: true,
      updateTs: '0',
    },
    type: UserDisplayDataType.User,
    deepLink: personalizedUser.deepLinkInfo?.deepLink || '',
    bio: '',
    contactName: user?.username || '',
    isFriend: false,
    isUnknown: true,
    verified: false,
    blockedByMe: { ts: '0', value: false },
    blockedMe: { ts: '0', value: false },
    displayName: user?.displayName || '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    middleName: user?.middleName || '',
  };
}

export function mapIOnlineUserData(userStatus: UserStatus): IOnlineUserData {
  return {
    userId: userStatus.userId.toString(),
    status: mapOnlineUserDataStatusEnum(userStatus.status),
    lastOnlineTs: userStatus.lastOnlineTs.toString(),
    event: '',
  };
}

export function mapOnlineUserDataStatusEnum(userStatus: UserStatus_Status): UserOnlineStatus {
  if (userStatus === UserStatus_Status.OFFLINE) {
    return UserOnlineStatus.Offline;
  }

  return UserOnlineStatus.Online;
}

export function mapIUser(user: User): IUser {
  return {
    id: user.id.toString(),
    phone: clearPhoneNumber(user.phone),
    avatarUrl: user.avatarUrl,
    updateTs: user.updateTs,
    position: user.position,
    userName: user.username,
    nickName: user.nickname,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    middleName: user.middleName,
    displayName: user.displayName,
  };
}

export function mapGetUsersByEmailRequest(
  data: IGetUsersByEmailsParams
): WsRequest<GetUsersByEmailsRequest> {
  return {
    email: data.email,
  };
}
